const init = () => {
    const collapseBlocks = document.querySelectorAll<HTMLElement>('.sts-text-editor.has-collapse');

    collapseBlocks.forEach((block) => {
        const content = block.querySelector<HTMLElement>('.sts-text-editor__content-inner');
        const toggle = block.querySelector<HTMLButtonElement>('.sts-collapse-toggle');

        if (!content || !toggle) return;

        const collapseText = toggle.dataset.collapseText || 'Show less';
        const expandText = toggle.dataset.expandText || 'Show more';

        toggle.addEventListener('click', () => {
            const isExpanded = block.classList.contains('has-collapse--expanded');
            const contentHeight = content.clientHeight;
            block.classList.toggle('has-collapse--expanded');
            block.style.setProperty('--content-height', `${contentHeight}px`);

            if (isExpanded) {
                const collapseHeight = block.dataset.collapseHeight || '300';
                toggle.textContent = collapseText;
                setTimeout(() => {
                    block.style.setProperty('--content-height', `${collapseHeight}px`);
                }, 0);
            } else {
                toggle.textContent = expandText;
                setTimeout(() => {
                    block.style.setProperty('--content-height', 'auto');
                }, 300);
            }
        });
    });
};

if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', init);
}
